import { Space, Tooltip, Typography } from 'antd'
import Link from 'next/link'
import TruncatedId from './TruncatedId'
import type { Image } from '@/models/ecs'

const { Text } = Typography
type ImageLinkProps = {
  image: Image
  primary?: boolean
  nameOnly?: boolean
}

const ImageLink = ({
  image,
  primary = false,
  nameOnly = true,
}: ImageLinkProps) => {
  if (!image || !image.id) {
    return <Text>-</Text>
  }

  const imageName = `${image.namespace}/${image.name}:${image.tag}`
  
  return (
    <Space direction='vertical' size={0}>
      <Link 
        className='text-[#1677ff] hover:text-[#69b1ff]'
        href={`/ecs/images/${image.id}`}>
        {primary ? (
          <Typography.Link>{imageName}</Typography.Link>
        ) : (
          <Typography.Text>{imageName}</Typography.Text>
        )}
      </Link>
      {!nameOnly && <TruncatedId id={image.id} />}
    </Space>
  )
}

export default ImageLink
